import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useGlobalStyles } from 'utils';
import { FullTable } from 'components';
import { LAST_LOADS, lastLoadsHead, lastLoadsBody } from './constants';
import { loadActions } from 'store';

export const LastLoads = ({}) => {
  const { carrierLastLoads } = useSelector((state) => ({
      carrierLastLoads: state.loads.carrierLastLoads,
    }),
  );
  const globalStyle = useGlobalStyles();
  const dispatch = useDispatch();
  const params = useParams();

  useEffect(() => {
    dispatch(loadActions.getCarrierLastLoads(params.id));
  }, []);

  return (
    <div style={{ marginTop: 0 }} className={globalStyle.tableWrapperNoShadow}>
      <FullTable
        head={lastLoadsHead}
        body={lastLoadsBody}
        loadingType={LAST_LOADS}
        list={carrierLastLoads?.length ? carrierLastLoads : []}
        noText={'Loads'}
      />
    </div>
  );
};
